import { HelpSections } from '@/api/consts'
import { Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { Motion } from '@/app/components/Motion/Motion'
import { Text } from '@/app/components/Text/Text'
import { Lib } from '@/app/components/UI/Lib'
import { UI } from '@/app/components/UI/UI'
import { useBack } from '@/app/hooks/useBack'
import type { FunctionalComponent } from 'preact'

export const HelpPage: FunctionalComponent = () => {
  const back = useBack('~/tools')

  return (
    <Layout>
      <Layout.Content
        onBack={back}
      >
        <Motion>
          <Layout.Header>
            Помощь
          </Layout.Header>
          <Row gap={30}>
            <Row gap={10}>
              <UI.Panel type='holder'>
                <Text
                  upper
                  fontSize={12}
                  opacity={0.5}
                >
                  Аккаунт и вход
                </Text>
              </UI.Panel>

              <Lib.SystemMessage
                hover
                link={`~/help/${HelpSections.LoginExistingAccount}`}
              >
                Как войти в существующий аккаунт?
              </Lib.SystemMessage>

              <Lib.SystemMessage
                hover
                link={`~/help/${HelpSections.SwitchAccount}`}
              >
                Как сменить аккаунт?
              </Lib.SystemMessage>

              <Lib.SystemMessage
                hover
                link={`~/help/${HelpSections.EmailCodeNotReceived}`}
              >
                Не приходит код на почту?
              </Lib.SystemMessage>

              <Lib.SystemMessage
                hover
                link={`~/help/${HelpSections.PurchaseAccountEmail}`}
              >
                К какой почте привязывается покупка?
              </Lib.SystemMessage>
            </Row>

            <Row gap={10}>
              <UI.Panel type='holder'>
                <Text
                  upper
                  fontSize={12}
                  opacity={0.5}
                >
                  Оплата и сообщения
                </Text>
              </UI.Panel>

              <Lib.SystemMessage
                hover
                link={`~/help/${HelpSections.PaidPackageNotShowing}`}
              >
                Оплаченный пакет не отображается.
              </Lib.SystemMessage>
            </Row>

            <Row gap={10}>
              <UI.Panel type='holder'>
                <Text
                  upper
                  fontSize={12}
                  opacity={0.5}
                >
                  Данные профиля
                </Text>
              </UI.Panel>

              <Lib.SystemMessage
                hover
                link={`~/help/${HelpSections.DataAndCalculationsMissing}`}
              >
                Пропали данные и расчёты.
              </Lib.SystemMessage>
            </Row>

            <UI.Button
              size='l'
              type='secondary'
              htmlType='button'
              onClick={back}
            >
              Назад
            </UI.Button>
          </Row>
        </Motion>
      </Layout.Content>
    </Layout>
  )
}
